import { render, staticRenderFns } from "./PreviewAmenities.vue?vue&type=template&id=db0cdb08&"
import script from "./PreviewAmenities.vue?vue&type=script&lang=js&"
export * from "./PreviewAmenities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports